import { useEffect, useState } from 'react';

// TODO: Consider adding a "don't auto update" button
export const useCurrentTimeToTheMinute = () => {
  // 0 for a fixed time for server-side rendering
  const [currentTime, setCurrentTime] = useState(new Date(0));

  useEffect(() => {
    let cancelled = false;
    let timeout: ReturnType<typeof setTimeout> | null = null;

    const updateCurrentTime = () => {
      if (!cancelled) {
        setCurrentTime(new Date());
        timeout = setTimeout(updateCurrentTime, 60000 - (Date.now() % 60000));
      }
    };

    updateCurrentTime();

    return () => {
      cancelled = true;

      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);

  return currentTime;
};
